const menuItemStyle = {
  borderRadius: 2,
  py: 1,
  px: 1.5,
  "&:hover": {
    background: "rgba(255,255,255,0.08)",
  },
};

export default menuItemStyle;